import React from 'react';
import { withTranslations, WithTranslations } from '../../../../utils/withTranslations';
import { ReactComponent as ArrowLeft } from '../../../../Icons/ArrowLeft.svg';
import s from './BackToListButton.scss';

interface BackToListButtonProps extends WithTranslations {
  dataHook?: string;
}

const BackToListButtonCmp: React.FC<BackToListButtonProps> = ({ t, dataHook }) => {
  const handleClick = () => {
    history.back();
  };

  return (
    <button data-hook={dataHook} className={s.button} onClick={handleClick}>
      <ArrowLeft className={s.arrow} />
      <span>{t('template.newMobileFlow.preview.back')}</span>
    </button>
  );
};

export const BackToListButton = withTranslations(BackToListButtonCmp);
